
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import CircleCharts, { type CircleChartsConfig } from './charts/CircleCharts.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    CircleCharts,
    LazyImg
  }
})
export default class SummaryStudyProcess extends Vue {
  circleConfig: CircleChartsConfig = {
    radius: 62,
    thickness: 14,
    startAngle: -Math.PI / 2,
    fillColor: '#E0BF95',
    bgColor: '#fff',
    count: 10,
    process: 7
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
